module.exports = __webpack_public_path__ + "static/media/thumb.f977b757.png";